<template>
  <div>
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-card v-if="isLogin">
        <v-card-title primary-title>
          <v-icon>account_circle</v-icon>
          <div class="title mb-0">
            <span style="margin-left: 50px;">{{ name }}</span>
          </div>
        </v-card-title>
      </v-card>

      <v-subheader>{{ function_text }}</v-subheader>
      <v-list>
        <template v-for="item in items">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group v-else-if="item.children" :key="item.text" v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile v-for="(child, i) in item.children" :key="i">
              <v-list-tile v-if="child.isLink" :href="child.url" target="_blank">
                <v-list-tile-action>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ child.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-else :to="child.url">
                <v-list-tile-action>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ child.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text + '-tile'">
            <v-list-tile v-if="item.isLink" :key="item.text + '-link'" :href="item.url" target="_blank">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else :key="item.text + '-route'" :to="item.url">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="primary" dark app data-app>
      <v-toolbar-title class="headline text-uppercase">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span>{{ title_text + " – " + page_name }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items data-app>
        <v-btn class="subheading" to="/login" flat v-if="!isLogin && showLogin && !useSSO">{{ login_text }}</v-btn>
        <v-btn class="subheading" flat v-on:click="login" v-if="!isLogin && useSSO">{{ login_text }}</v-btn>
        <v-btn class="subheading" flat v-if="isLogin && showLogin && !useSSO" v-on:click="logout">{{ logout_text
        }}</v-btn>
        <v-btn class="subheading" flat v-if="isLogin && useSSO" v-on:click="AMlogout">{{ logout_text }}</v-btn>
        <v-menu offset-y fixed attach :close-on-content-click="false" :nudge-width="250" :max-height="400"
          v-model="showMenu" v-if="isLogin && showLogin">
          <template v-slot:activator="{ on }">
            <v-btn flat v-on="on">
              <v-badge color="success" left>
                <template v-slot:badge>
                  <span>{{ select_course_length }}</span>
                </template>
                <v-icon color="secondary">view_list</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-card>
            <v-list style="padding: 0px;" v-for="(item, index) in select_course" :key="index">
              <v-list-tile avatar>
                <v-list-tile-action>
                  <v-btn flat icon v-on:click="deleteSelectCourse(item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>({{ item.Semester }}) {{ item.CourseNo }}
                    {{ item.CourseName }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </v-list>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat v-on:click="showMenu = false">確定</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

        <v-menu fixed offset-y attach>
          <v-btn class="subheading" slot="activator" flat>
            {{ semesters_text }} ： {{ selectedSemesterDisplay }}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, index) in semesters" :key="index" v-on:click="selectSemester(item.Semester)">
              <v-list-tile-title>{{ select_language.lang === 'en' ? item.EngSemester : item.Semester }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-menu offset-y attach>
          <v-btn class="subheading" slot="activator" flat>
            <!--
            <span class="flag-icon mx-2" :class="select_language.icon"></span>
            {{ select_language.text }}
            -->
            <span>Language</span>
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, index) in languages" :key="index" v-on:click="setLanguageChoose(item)">
              <v-list-tile-avatar>
                <span class="flag-icon" :class="item.icon"></span>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import languages from "../languages/Navigation.json";

// eslint-disable-next-line no-unused-vars
import VueCookie from "vue-cookies";


function sanitizeUrl(url) {
  if (!url) return "/";
  try {
    const decoded = decodeURIComponent(url);
    return decoded.split("#")[0]; // 移除 fragment (#)
  } catch {
    return "/";
  }
}

export default {
  data: () => ({
    drawer: true,
    title_text: "",
    old_version: "",
    semesters_text: "",
    login_text: "",
    logout_text: "",
    notlogin_text: "",
    function_text: "",
    archived_course_title_and_outline: "",
    course_information: "",
    useSSO: true,
    SSOLink: "",
    items: [],
    showMenu: false,
  }),
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    name() {
      return this.$store.state.name;
    },
    select_course() {
      return this.$store.state.select_course;
    },
    select_course_length() {
      return this.$store.state.select_course.length;
    },
    semesters() {
      return this.$store.state.semesters.filter((x) => x.CurrentSemester);
    },
    select_semester() {
      return this.$store.state.select_semester;
    },
    languages() {
      return this.$store.state.languages;
    },
    select_language() {
      return this.$store.state.select_language;
    },
    showLogin() {
      return this.$store.state.showLogin;
    },
    page_name() {
      return languages[this.$route.name][this.select_language.lang];
    },
      selectedSemesterDisplay() {
          const selected = this.semesters.find(x => x.Semester === this.select_semester);
          if (!selected) return this.select_semester;

          return this.select_language.lang === 'en'
              ? selected.EngSemester
              : selected.Semester;
      }
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
    this.getUseSSO();
  },
  methods: {
    getUseSSO() {
      fetch("api/usesso")
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.useSSO = data["useSSO"];
          this.SSOLink = data["SSOLink"];
        });
    },
    login: function () {
      const currentUrl = encodeURIComponent(window.location.href);

      const apiUrl = process.env.VUE_APP_API_BASE_URL+"/";

      var controllerConfig = 'OAuth2';

      window.location.href = `${apiUrl}${controllerConfig}/Login?returnUrl=${currentUrl}`;
    },
    logout: async function () {
      try {
        const apiUrl = process.env.VUE_APP_API_BASE_URL+"/";
        const controller = "OAuth2";

        const cleanUrl = sanitizeUrl(window.location.href);
        const encodedReturn = encodeURIComponent(cleanUrl);

        window.location.href = `${apiUrl}${controller}/Logout?returnUrl=${encodedReturn}`;
      } catch (err) {
        console.error("❌ logout error:", err);
      }
    },
    AMlogout: async function () {
      try {
        const apiUrl = process.env.VUE_APP_API_BASE_URL+"/";
        const controller = "OAuth2";

        const cleanUrl = sanitizeUrl(window.location.href);
        const encodedReturn = encodeURIComponent(cleanUrl);

        window.location.href = `${apiUrl}${controller}/Logout?returnUrl=${encodedReturn}`;
      } catch (err) {
        console.error("❌ AMlogout error:", err);
      }
    },
    selectSemester: function (select_semester) {
      this.$store.commit("setSelectSemester", select_semester);
    },
    deleteSelectCourse: function (select_course) {
      this.$store.dispatch("deleteSelectCourse", select_course);
    },
    setLanguageChoose: function (select_language) {
      this.$store.commit("setSelectLanguage", select_language);
    },
    setLanguage: function (select_language) {
      this.title_text = languages.title[select_language.lang];
      this.old_version = languages.old_version[select_language.lang];
      this.semesters_text = languages.semesters[select_language.lang];
      this.login_text = languages.login[select_language.lang];
      this.logout_text = languages.logout[select_language.lang];
      this.notlogin_text = languages.notlogin[select_language.lang];
      this.function_text = languages.functions[select_language.lang];
      this.archived_course_title_and_outline =
        languages.archived_course_title_and_outline[select_language.lang];
      this.course_information =
        languages.course_information[select_language.lang];

      this.items = [
        {
          icon: "search",
          text: languages.general_search[select_language.lang],
          url: "/",
          isLink: false,
        },
        {
          icon: "list_alt",
          text: languages.class_schedule[select_language.lang],
          url: "/ClassSchedule",
          isLink: false,
        },
        {
          icon: "help",
          text: languages.cancelled_course[select_language.lang],
          url: "/CancleCourse",
          isLink: false,
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: languages.old_course[select_language.lang],
          model: false,
          children: [
            {
              icon: "history",
              text: languages.old_course[select_language.lang],
              url: "/OldCourse",
              isLink: false,
            },
            {
              icon: "collections_bookmark",
              text: languages.archived_course[select_language.lang],
              url: "/ArchivedCourse",
              isLink: false,
            },
            {
              icon: "menu_book",
              text:
                languages.archived_course_title_and_outline[
                select_language.lang
                ],
              url: "/CourseTitleAndOutline",
              isLink: false,
            },
          ],
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: languages.course_information[select_language.lang],
          model: false,
          children: [
            {
              icon: "info",
              text: languages.course_relevant_info[select_language.lang],
              url: "https://www.academic.ntust.edu.tw/p/412-1048-8232.php?Lang=zh-tw",
              isLink: true,
            },
            {
              icon: "map",
              text: languages.curriculum_mapping[select_language.lang],
              url:
                "https://www.academic.ntust.edu.tw/p/404-1048-78991.php?Lang=zh-tw",
              isLink: true,
            },
            {
              icon: "person_pin",
              text: languages.faculty_department[select_language.lang],
              url:
                "https://www.academic.ntust.edu.tw/p/404-1048-78991.php?Lang=zh-tw",
              isLink: true,
            },
          ],
        },
      ];
    },
  },
};

</script>
